export default async function getToken(data) {
  return new Promise((success, error) => {
    const { Iugu } = window;
    const { name, cardNumber, month, year, cvv } = data;
    const firstName = name.split(' ')[0];
    const lastName = name
      .split(' ')
      .splice(1)
      .join(' ');
    const cc = Iugu.CreditCard(cardNumber, month, year, firstName, lastName, cvv);

    Iugu.setAccountID(process.env.VUE_APP_IUGU_ACCOUNT_ID);
    Iugu.setTestMode(sessionStorage.getItem('env') !== 'production');

    if (Iugu.utils.validateCreditCardNumber(cardNumber)) {
      Iugu.createPaymentToken(cc, response => {
        if (response.errors) {
          error(
            new Error(
              'Erro na geração do token de segurança. Tente novamente ou entre em contato com nossa central de atendimento.'
            )
          );
        }

        success(response.id);
      });
    } else {
      error(new Error('Cartão inválido: confirme o número digitado.'));
    }
  });
}
